import type { CmsProps } from '../../../types/cms'
import styled from '@emotion/styled'
import { Background } from '../../surfaces/background'

export const BeforeAndAfterBackground = styled(Background)<CmsProps>`
  background-color: ${({ backgroundColour }) => backgroundColour ?? '#FFF'};
  h2 {
    text-align: center;
    margin-bottom: 2rem;
    color: ${({ textColour }) => textColour || '#FFF'};
  }
`
